import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconSettings } from "@tabler/icons-react";
import { ClientesConfiguracionDef } from "./ClientesConfiguracionDef";

export const ClientesConfiguracionIcon = IconSettings;
export const ClientesConfiguracionHelpText = '* Seleccione el cliente para configurar las tiendas, productos y servicios';

export class ClientesConfiguracion extends Entity<ClientesConfiguracionDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ClientesConfiguracionDef(), parentKeys);
        this.Form = import('./ClientesConfiguracionForm').then((module) => module.ClientesConfiguracionForm);
        this.Title = "Configuración de Clientes, Tiendas, Productos y Servicios";
        this.HelpText = ClientesConfiguracionHelpText;
        this.Icon = ClientesConfiguracionIcon;
    }
}